class NotePresenter {
  constructor(note) {
    this.note = note;
    if (note?.gen_patient_updates) {
      this.patientUpdates = Object.entries(note.gen_patient_updates).reduce((acc, [key, value]) => {
        if (key.startsWith('gen_')) {
          acc[key.substring(4)] = value;
        } else {
          acc[key] = value;
        }
        return acc;
      }, {});
    }
  }

  getUUID() {
    return this.note?.uuid;
  }

  getBody() {
    return this.note?.user_body ? this.note.user_body : this.note?.gen_body;
  }

  getSummary() {
    return this.note?.gen_summary || (this.note?.gen_body?.substring(0, 150).replace(/#/g, "") + '...');
  }

  hasInsights() {
    return Boolean(
      this.getConsiderations() || this.getInconsistencies()
    );
  }

  getConsiderations() {
    return this.note?.gen_considerations;
  }

  getInconsistencies() {
    return this.note?.gen_inconsistencies;
  }

  // returns true if there are any values in the patient updates
  hasPatientUpdates() {
    if (!this.patientUpdates) return false;
    
    return Object.values(this.patientUpdates).some(value => value !== null && value !== undefined && value !== '');
  }

  // returns the patient updates if there are any
  getPatientUpdates() {
    if (!this.hasPatientUpdates()) return null;
    return this.patientUpdates;
  }

  setUserBody(body) {
    if (!this.note) {
      throw new Error('Cannot set user body on a null note.');
    }
    this.note.user_body = body;
  }

  isDoctorNote() {
    return Boolean(
      this.note &&
      this.note.note_type_slug &&
      this.note.note_type_slug !== 'patient_instructions'
    );
  }

  isComplete() {
    return Boolean(this.note && this.note.completed && this.getBody());
  }

  isValid() {
    return Boolean(
      this.note &&
      this.isComplete() &&
      this.getBody() &&
      !this.note.problem
    );
  }

  getTitle() {
    return this.note?.gen_title || this.note?.default_title;
  }

  getNoteType() {
    return this.note?.note_type_slug;
  }

  canBeRegenerated() {
    return Boolean(this.isValid());
  }

  getCreatedAt() {
    return this.note?.created_at;
  }
}

export default NotePresenter;
